export default {
  '***': {
    '***': [
      {
        "id": 100,
        "label": "Brand Image",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          105,
          110,
          111,
          115,
          120
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 200,
        "label": "Creative Type",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          205,
          210,
          215,
          220
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 300,
        "label": "Creative Style",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          305,
          310,
          315,
          320,
          325,
          330,
          335,
          340,
          345
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 105,
        "label": "Awards/Accolades",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Refers to any reference of awards or rankings, 3rd party or commissioned research based."
      },
      {
        "id": 110,
        "label": "Customer Service",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Refers to a primary focus on customer service"
      },
      {
        "id": 111,
        "label": "Co-Brand",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Single ad advertising for more than one brand ('Seamless + Taco Bell' or 'Marriott Chase credit card')"
      },
      {
        "id": 115,
        "label": "General Reputation",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "Refers to any ad that focuses on a brand's general reputation, but does not mention any products"
      },
      {
        "id": 120,
        "label": "Sponsorship",
        "selected": 0,
        "collapse": 0,
        "parent": 100,
        "children": [],
        "tooltip": "No tooltip provided"
      },
      {
        "id": 205,
        "label": "Narrative",
        "selected": 0,
        "collapse": 0,
        "parent": 200,
        "children": [],
        "tooltip": "Ad follows a story trajectory, even if short"
      },
      {
        "id": 210,
        "label": "Vignette/Montage",
        "selected": 0,
        "collapse": 0,
        "parent": 200,
        "children": [],
        "tooltip": "Ad does not have a story, but rather many different scenes cut together"
      },
      {
        "id": 215,
        "label": "Animated",
        "selected": 0,
        "collapse": 0,
        "parent": 200,
        "children": [],
        "tooltip": "At least half of ad is cartoon/animation and not filmed"
      },
      {
        "id": 220,
        "label": "Graphics/Product Images Only",
        "selected": 0,
        "collapse": 0,
        "parent": 200,
        "children": [],
        "tooltip": "Ad is a computer generated ad usually focusing on a product with few or no actual filmed scenes"
      },
      {
        "id": 305,
        "label": "Humorous",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "The intent of the ad is to make you laugh"
      },
      {
        "id": 310,
        "label": "Emotional",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "The intent of the ad is to elicit sad or heartwarming emotion"
      },
      {
        "id": 325,
        "label": "Spokesperson",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "Includes both celebrity and non-celebrity spokespeople"
      },
      {
        "id": 315,
        "label": "Celebrity (for brand NOT content)",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "Includes any celebrity inclusion, whether or not that person is a spokesperson"
      },
      {
        "id": 335,
        "label": "Music (jingle)",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "Refers to a consistent jingle associated with a brand, not just background music"
      },
      {
        "id": 320,
        "label": "Music (lyrics/song)",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "Refers to an identifiable song - either lyrics or instrumental"
      },
      {
        "id": 340,
        "label": "Branding in Intro (First 5 seconds)",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "The advertising brand is shown or spoken in the first 5 seconds"
      },
      {
        "id": 330,
        "label": "Voice Over Narration",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "An off-screen narrator is featured"
      },
      {
        "id": 345,
        "label": "Continuity",
        "selected": 0,
        "collapse": 0,
        "parent": 300,
        "children": [],
        "tooltip": "Ad uses the same creative construct and/or established brand cues"
      },
      {
        "id": 400,
        "label": "Seasonal",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          405,
          410,
          415,
          420
        ],
        "tooltip": ""
      },
      {
        "id": 405,
        "label": "Spring",
        "selected": 0,
        "collapse": 0,
        "parent": 400,
        "children": [],
        "tooltip": "Describes what season the ad was aired in"
      },
      {
        "id": 410,
        "label": "Summer",
        "selected": 0,
        "collapse": 0,
        "parent": 400,
        "children": [],
        "tooltip": "Describes what season the ad was aired in"
      },
      {
        "id": 415,
        "label": "Fall",
        "selected": 0,
        "collapse": 0,
        "parent": 400,
        "children": [],
        "tooltip": "Describes what season the ad was aired in"
      },
      {
        "id": 420,
        "label": "Winter",
        "selected": 0,
        "collapse": 0,
        "parent": 400,
        "children": [],
        "tooltip": "Describes what season the ad was aired in"
      },
      {
        "id": 500,
        "label": "Holiday Focused",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          505,
          510
        ],
        "tooltip": ""
      },
      {
        "id": 505,
        "label": "Yes",
        "selected": 0,
        "collapse": 0,
        "parent": 500,
        "children": [
         
        ],
        "tooltip": "Holiday focus"
      },
      {
        "id": 510,
        "label": "No",
        "selected": 0,
        "collapse": 0,
        "parent": 500,
        "children": [
      
        ],
        "tooltip": "Non-holiday focus"
      },
      {
        "id": 600,
        "label": "Loyalty Program",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          605,
          610
        ],
        "tooltip": ""
      },
      {
        "id": 605,
        "label": "Yes",
        "selected": 0,
        "collapse": 0,
        "parent": 600,
        "children": [
         
        ],
        "tooltip": "Features a loyalty program (i.e. Target Circle, Walmart+, Amazon Prime)"
      },
      {
        "id": 610,
        "label": "No",
        "selected": 0,
        "collapse": 0,
        "parent": 600,
        "children": [
      
        ],
        "tooltip": "Does not feature a loyalty program (i.e. Target Circle, Walmart+, Amazon Prime)"
      },
      {
        "id": 700,
        "label": "Primary Message",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          705,
          710,
          715,
          720,
          725
        ],
        "tooltip": ""
      },
      {
        "id": 705,
        "label": "Affordability",
        "selected": 0,
        "collapse": 0,
        "parent": 700,
        "children": [
        ],
        "tooltip": "Affordability: sales promotions or deals, everyday low prices, quality products at a good price"
      },
      {
        "id": 710,
        "label": "Ease",
        "selected": 0,
        "collapse": 0,
        "parent": 700,
        "children": [
        ],
        "tooltip": "Ease/Services: fast delivery, rewards program, drive up / pickup services, app, free shipping, subscription services, credit/debit card"
      },
      {
        "id": 715,
        "label": "Assortment",
        "selected": 0,
        "collapse": 0,
        "parent": 700,
        "children": [
        ],
        "tooltip": "Assortment: one stop shop, exclusive products, seasonal products, on trend products, gift ideas, broad product assortment, new brands"
      },
      {
        "id": 720,
        "label": "Experience",
        "selected": 0,
        "collapse": 0,
        "parent": 700,
        "children": [
        ],
        "tooltip": "Experience: convenient to shop, stress-free shopping, pleasant experience, fun to shop"
      },
      {
        "id": 725,
        "label": "Community",
        "selected": 0,
        "collapse": 0,
        "parent": 700,
        "children": [
        ],
        "tooltip": "Community: community giving, community support, customer safety, employee appreciation"
      },
      {
        "id": 800,
        "label": "Audience Focus",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          805,
          810,
          815,
          820,
          825
        ],
        "tooltip": ""
      },
      {
        "id": 805,
        "label": "Parents",
        "selected": 0,
        "collapse": 0,
        "parent": 800,
        "children": [
        ],
        "tooltip": "Audience target/featured"
      },
      {
        "id": 810,
        "label": "Black Americans",
        "selected": 0,
        "collapse": 0,
        "parent": 800,
        "children": [
        ],
        "tooltip": "Audience target/featured"
      },
      {
        "id": 815,
        "label": "Latino",
        "selected": 0,
        "collapse": 0,
        "parent": 800,
        "children": [
        ],
        "tooltip": "Audience target/featured"
      },
      {
        "id": 820,
        "label": "AAPI",
        "selected": 0,
        "collapse": 0,
        "parent": 800,
        "children": [
        ],
        "tooltip": "Audience target/featured"
      },
      {
        "id": 825,
        "label": "LGBTQ",
        "selected": 0,
        "collapse": 0,
        "parent": 800,
        "children": [
        ],
        "tooltip": "Audience target/featured"
      },
    ]
  }
}


// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetailWalmart/config/components/selection/Search/tagHierarchy.js